import { store } from 'react-easy-state';
import getVideoId from 'get-video-id';

export const baseStore = store({
  windowHeight: 0,
  videoId: null,
  videoOpen: false,
  section: null,

  openVideo(e) {
    e.preventDefault();
    e.stopPropagation();
    const { id } = getVideoId(e.currentTarget.href);
    baseStore.videoId = id;
    baseStore.videoOpen = true;
  },

  waypointOffset() {
    return 400;
  }
});
